import {
  IonCard,
  IonCardContent,
  IonCol,
  IonItem,
  IonRow,
  IonText,
  IonThumbnail,
} from "@ionic/react";
import { useEffect, useState } from "react";
import ListVideo from "./ListVideo";

import { makePOSTRequest } from "../../request/rawRequest";
import { Theme } from "../../types/theme";
import "../generalCSS/stylesheet.css";
import "./List.css";

interface ContainerProps {
  generique?: boolean;
  theme?: Array<any>;
  compID?: string;
}

const ListTheme: React.FC<ContainerProps> = ({ generique, theme, compID }) => {
  const [themeList, setThemeList] = useState<any>([]);
  const [vvTitle, setvvTitle] = useState<Map<string, string>>(new Map());

  const getVideosByTheme = async (id_videos: any) => {
    let vids: any = [];
    await makePOSTRequest("/videos", { _id: id_videos }).then((data) => {
      vids = data;
    });
    return vids;
  };

  useEffect(() => {
    themeList.map((tl: any) => {
      let vv = 0;
      const vids = getVideosByTheme(tl.id_videos);
      vids.then((res) => {
        res.map((v: any) => {
          if (v.viewed === true) vv++;
        });
        setvvTitle((old) => {
          old.set(tl._id, vv + "/" + res.length);
          return new Map(old);
        });
      });
    });
  }, [themeList]);

  useEffect(() => {
    if (theme) {
      const themeLists: Theme[] = [];
      for (let i = 0; i < theme.length; i++) {
        themeLists.push(theme[i]);
      }
      setThemeList(theme);
    }
  }, []);

  return (
    <IonRow>
      <IonCol>
        {themeList.map((theme: any, i: number) => {
          if (generique === true) {
            return (
              <IonCard
                key={i}
                onClick={() => {
                  const videoReq = [];
                  const videos: { [key: string]: string }[] = [];

                  if (theme.id_videos.length === 1) {
                    window.location.href =
                      "auth/pole/videogen?" +
                      "&theme=" +
                      theme._id +
                      "&id=" +
                      theme.id_videos[0] +
                      "&compID=" +
                      compID;
                  } else {
                    for (const videoID of theme.id_videos) {
                      videoReq.push(
                        makePOSTRequest("/videos", { _id: videoID })
                          .then((res) => res[0])
                          .then((res) => ({
                            index: res.index,
                            _id: res._id,
                          }))
                          .then((res) => {
                            videos.push(res);
                          }),
                      );
                    }

                    Promise.all(videoReq).then(() => {
                      videos.sort(
                        (a, b) =>
                          Number.parseInt(a.index) - Number.parseInt(b.index),
                      );

                      window.location.href =
                        "auth/pole/videogen?" +
                        "&theme=" +
                        theme._id +
                        "&id=" +
                        videos[0]._id +
                        "&compID=" +
                        compID;
                    });
                  }
                }}
                color="light"
                className="card"
              >
                <IonCardContent className="card-content background-video-card no-padding">
                  <IonItem color="transparent">
                    <IonThumbnail
                      slot="start"
                      style={{ marginTop: "0", marginBottom: "0" }}
                      className="no-margin"
                    >
                      <img
                        alt="vignette"
                        src={
                          theme.picture_url.length > 0 &&
                          theme.picture_url !== "null"
                            ? theme.picture_url
                            : "https://t4.ftcdn.net/jpg/00/89/55/15/240_F_89551596_LdHAZRwz3i4EM4J0NHNHy2hEUYDfXc0j.jpg"
                        }
                        style={{
                          borderRadius: "100%",
                        }}
                      />
                    </IonThumbnail>
                    <div className="separator"></div>
                    <IonText>
                      <h5>{theme.name}</h5>
                      <span className="small-font">
                        {vvTitle.get(theme._id)
                          ? "vidéo vues " + vvTitle.get(theme._id)
                          : "Chargement ..."}
                      </span>
                    </IonText>
                  </IonItem>
                </IonCardContent>
              </IonCard>
            );
          }
          return (
            <ListVideo
              key={i}
              idTheme={theme._id}
              id_videos={theme.id_videos}
              generique={generique!}
              picture_url={theme.picture_url ?? ""}
              compID={generique && generique === true ? "" : compID}
            />
          );
        })}
      </IonCol>
    </IonRow>
  );
};

export default ListTheme;
